import {
  SEARCH_USERS,
  APPEND_SEARCH_USERS,
  SET_SEARCH_META,
  SET_LOADING,
  SET_SEARCH_LOADING,
  SET_FEATURED_LOADING,
  GET_REPOS,
  CLEAR_USERS,
  CLEAR_USER_SEARCH_RESULTS,
  GET_USER,
  SET_RATE_LIMIT,
  SET_API_ERROR,
  CLEAR_API_ERROR,
  CACHE_PROFILE,
  SET_FEATURED_USERS,
  SET_REPOS_FOR_LOGIN,
  APPEND_REPOS_FOR_LOGIN,
  SET_CARD_REPOS_LOADING,
  SET_LANGUAGE_STATS,
  SET_INSIGHT_LOGIN,
  SET_INSIGHT_BUNDLE,
  SEARCH_REPOS,
  CLEAR_REPO_SEARCH_RESULTS,
  SET_REPO_SEARCH_META,
  SET_REPO_SEARCH_LOADING,
} from "../types";

const githubReducer = (state, action) => {
  switch (action.type) {
    case SEARCH_USERS:
      return {
        ...state,
        users: action.payload,
        loading: false,
        searchLoading: false,
      };

    case APPEND_SEARCH_USERS:
      return {
        ...state,
        users: [...state.users, ...action.payload],
        loading: false,
        searchLoading: false,
      };

    case SET_SEARCH_META:
      return {
        ...state,
        searchMeta: { ...state.searchMeta, ...action.payload },
      };

    case CLEAR_USERS:
      return {
        ...state,
        users: [],
        loading: false,
        searchLoading: false,
        searchMeta: { total: 0, page: 1, perPage: 12 },
      };

    case CLEAR_USER_SEARCH_RESULTS:
      return {
        ...state,
        users: [],
      };

    case GET_REPOS:
      return {
        ...state,
        repos: action.payload,
        loading: false,
      };

    case GET_USER:
      return {
        ...state,
        user: action.payload,
        loading: false,
      };

    case SET_LOADING:
      return {
        ...state,
        loading: true,
      };

    case SET_SEARCH_LOADING:
      return {
        ...state,
        searchLoading: action.payload,
      };

    case SET_FEATURED_LOADING:
      return {
        ...state,
        featuredLoading: action.payload,
      };

    case SET_RATE_LIMIT:
      return {
        ...state,
        rateLimit: { ...state.rateLimit, ...action.payload },
      };

    case SET_API_ERROR:
      return {
        ...state,
        apiError: action.payload,
        searchLoading: false,
        repoSearchLoading: false,
        featuredLoading: false,
        loading: false,
      };

    case CLEAR_API_ERROR:
      return {
        ...state,
        apiError: null,
      };

    case CACHE_PROFILE:
      return {
        ...state,
        profilesByLogin: {
          ...state.profilesByLogin,
          [action.payload.login]: action.payload.profile,
        },
      };

    case SET_FEATURED_USERS:
      return {
        ...state,
        featuredUsers: action.payload,
        featuredLoading: false,
      };

    case SET_REPOS_FOR_LOGIN: {
      const { login, repos, page, hasMore, sort } = action.payload;
      return {
        ...state,
        reposByLogin: {
          ...state.reposByLogin,
          [login]: {
            items: repos,
            page,
            hasMore,
            sort,
            loading: false,
          },
        },
      };
    }

    case APPEND_REPOS_FOR_LOGIN: {
      const { login, repos, page, hasMore } = action.payload;
      const prev = state.reposByLogin[login] || { items: [] };
      return {
        ...state,
        reposByLogin: {
          ...state.reposByLogin,
          [login]: {
            ...prev,
            items: [...prev.items, ...repos],
            page,
            hasMore,
            loading: false,
          },
        },
      };
    }

    case SET_CARD_REPOS_LOADING: {
      const { login, loading } = action.payload;
      const prev = state.reposByLogin[login] || { items: [] };
      return {
        ...state,
        reposByLogin: {
          ...state.reposByLogin,
          [login]: { ...prev, loading },
        },
      };
    }

    case SET_LANGUAGE_STATS:
      return {
        ...state,
        languageStatsByLogin: {
          ...state.languageStatsByLogin,
          [action.payload.login]: action.payload.stats,
        },
      };

    case SET_INSIGHT_LOGIN:
      return {
        ...state,
        insightLogin: action.payload,
      };

    case SET_INSIGHT_BUNDLE:
      return {
        ...state,
        insightByLogin: {
          ...state.insightByLogin,
          [action.payload.login]: action.payload.data,
        },
      };

    case SEARCH_REPOS:
      return {
        ...state,
        repoResults: action.payload,
        repoSearchLoading: false,
      };

    case CLEAR_REPO_SEARCH_RESULTS:
      return {
        ...state,
        repoResults: [],
      };

    case SET_REPO_SEARCH_META:
      return {
        ...state,
        repoSearchMeta: { ...state.repoSearchMeta, ...action.payload },
      };

    case SET_REPO_SEARCH_LOADING:
      return {
        ...state,
        repoSearchLoading: action.payload,
      };

    default:
      return state;
  }
};

export default githubReducer;
